<template>
  <Section>
    <template #header>
      <div class="mr-auto">
        <strong style="color:black">Notes</strong>
      </div>
      
      <NotesDialog />
    </template>

   {{ currentPro.notes }}
  </Section>
</template>

<script>
  import { Section } from '@/components/pages'
  import NotesDialog from '../dialogs/Notes.vue'

  import { mapGetters } from 'vuex'

  export default {
    name: 'ProNotesSection',
    
    components: { Section, NotesDialog },

    computed: {
      ...mapGetters('pros', ['currentPro']),
    },

  }

</script>
